// Stable identity for a ledger row. Never the array index: loading an older
// page prepends records, and an index key would move every row the user is
// looking at.
export const recordKey = (rec) => rec.id;

const KIND_LABELS = {
  user: 'Пользователь',
  human_answer: 'Ответ',
  agent_question: 'Вопрос',
  decision: 'Решение',
  agent_run: 'Агент',
  artifact: 'Артефакт',
  routing_round: 'Роутинг',
  agent_message: 'Сообщение',
};

export const kindLabel = (kind) => KIND_LABELS[kind] || kind;

/**
 * `—` when the duration is unknown. Never a live-elapsed guess: a running task
 * and an unanswered question genuinely have no measured span yet, and inventing
 * one would make the timeline lie.
 */
export function formatDuration(ms) {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return '—';
  if (ms < 1000) return `${ms} ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(ms < 10_000 ? 2 : 1)} s`;
  const minutes = Math.floor(ms / 60_000);
  const seconds = Math.round((ms % 60_000) / 1000);
  return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
}

export function formatClock(ts) {
  if (!ts) return '—';
  const d = new Date(ts);
  return d.toLocaleTimeString('ru-RU', { hour12: false }) +
    '.' + String(d.getMilliseconds()).padStart(3, '0');
}

// Which by-id endpoint carries this record's full payload.
//
// `agent_message` is absent on purpose: there is no by-id endpoint for one
// message, and there does not need to be. The ledger row already carries the
// sender, the recipient and a preview of the body, which is the whole record —
// unlike an artifact or a task, a message has no larger payload hiding behind
// it. The inspector shows what the row has rather than calling nothing and
// rendering an empty panel.
export const DETAIL_PATH = {
  artifact: (id) => `/artifacts/${id}`,
  task: (id) => `/tasks/${id}`,
  decision_record: (id) => `/decision-records/${id}`,
  human_request: (id) => `/human-requests/${id}`,
};
